import { Input } from "@/components/ui/input";

const MATCH_LABEL = { tracking: "Tracking", "tracking~": "Tracking (near)", sr_no: "Sr. No." };

const StatusPill = ({ row, overwrite }) => {
  if (row.weight === "" || row.weight === null) return <span className="text-amber-700">No reading</span>;
  if (row.current_weight && !overwrite) return <span className="text-slate-500">Skip (has weight)</span>;
  if (row.needs_review) return <span className="text-amber-700 font-semibold">Review</span>;
  return <span className="text-emerald-700 font-semibold">OK</span>;
};

export const ScanReviewTable = ({ rows, setRows, overwrite }) => {
  const edit = (i, key, val) => setRows(rows.map((r, j) => (j === i ? { ...r, [key]: val, needs_review: key === "weight" ? false : r.needs_review } : r)));
  return (
    <div className="max-h-[55vh] overflow-auto border rounded" data-testid="scan-weights-review">
      <table className="w-full text-xs">
        <thead className="bg-slate-50 sticky top-0 z-10">
          <tr>
            <th className="p-2 text-left">Sr</th>
            <th className="p-2 text-left">Customer</th>
            <th className="p-2 text-left">Tracking</th>
            <th className="p-2 text-center">Current (g)</th>
            <th className="p-2 text-center w-28">Scanned weight (g)</th>
            <th className="p-2 text-center w-20">Packer</th>
            <th className="p-2 text-left">Matched by</th>
            <th className="p-2 text-left">Status</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={r.tracking || i} data-testid={`scan-row-${i}`}
              className={`border-t ${r.needs_review ? "bg-amber-50" : ""}`}>
              <td className="p-2">{r.sr_no}</td>
              <td className="p-2 font-medium truncate max-w-[160px]">{r.name}</td>
              <td className="p-2 font-mono">{r.tracking}</td>
              <td className="p-2 text-center text-slate-500" data-testid={`scan-row-current-${i}`}>{r.current_weight ?? "—"}</td>
              <td className="p-1 text-center">
                <Input type="number" min="0" className={`h-7 w-24 text-xs mx-auto text-center ${r.needs_review ? "border-amber-400" : ""}`}
                  value={r.weight} data-testid={`scan-row-weight-${i}`}
                  onChange={(e) => edit(i, "weight", e.target.value)} />
              </td>
              <td className="p-1 text-center">
                <Input className="h-7 w-16 text-xs mx-auto text-center uppercase" maxLength={6}
                  value={r.packer} data-testid={`scan-row-packer-${i}`}
                  onChange={(e) => edit(i, "packer", e.target.value.toUpperCase())} />
              </td>
              <td className="p-2 text-slate-500">
                {MATCH_LABEL[r.matched_by] || "—"}
                {r.confidence && r.confidence !== "high" && <span className="ml-1 text-amber-700">({r.confidence})</span>}
              </td>
              <td className="p-2" data-testid={`scan-row-status-${i}`}><StatusPill row={r} overwrite={overwrite} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
